export default __webpack_public_path__ + "static/media/SndLowerUDownTravelUpBump.d7417511.mp3";